import type { oz } from '@weft/utils';
import { created } from '../../utils';
import { MeterSchema } from '../meter';
import { NewProductVariantSchema } from './new-product-variant-schema';

export const ProductVariantSchema = created(
  NewProductVariantSchema
    .extend({
      meter: MeterSchema.nullable(),
    }),
).openapi('ProductVariant');

export type ProductVariant = oz.infer<typeof ProductVariantSchema>;